import { render, staticRenderFns } from "./volume.vue?vue&type=template&id=2d30ada6&lang=pug"
import script from "./volume.vue?vue&type=script&lang=js"
export * from "./volume.vue?vue&type=script&lang=js"
import style0 from "./volume.vue?vue&type=style&index=0&id=2d30ada6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports